import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Row, Col } from 'antd';

const ContentRow = ({ name, value, show = true }) => {
  if (_.isNil(value) || !show) {
    return null;
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xl={5} sm={7} xs={24}>
        <strong>{name}</strong>
      </Col>
      <Col xl={19} sm={17} xs={24}>
        {value}
      </Col>
    </Row>
  );
};

ContentRow.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  show: PropTypes.bool,
};

ContentRow.defaultProps = {
  show: true,
};

export default ContentRow;
